import { ResponseType, IResponseOptionsArgs } from './interfaces';
import shellapi from 'a365-shell-api';

/**
 * ResponseOptions used to construct a Response.
 * This class should not be required outside of the http module.
 */
export class ResponseOptions {
    public body: string | object | ArrayBuffer | Blob | null;
    public status: number | null;
    public headers: shellapi.http.IHeaders | null;
    public statusText: string | null;
    // eslint-disable-next-line
    public type: ResponseType | null;
    public url: string | null;
    constructor(opts: IResponseOptionsArgs = {}) {
    const {body, status, headers, statusText, type, url} = opts;
        this.body = body != null ? body : null;
        this.status = status != null ? status : null;
        this.headers = headers != null ? headers : null;
        this.statusText = statusText != null ? statusText : null;
        this.type = type != null ? type : null;
        this.url = url != null ? url : null;
    }
}
